import React, {Component, useState, useEffect} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import BlogContent from '../components/BlogContent'; 
import axios from 'axios'; 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import withRouter from '../components/withRouter';
import EditProfile , {AppWithNavigate} from './components/EditProfile';

class UserEditProfile extends React.Component{

    constructor(){
        super();  
    }
 
    render()
    { 
        return (
            <div>
                <Header/> 
                <PageHeader title="Edit profile" />
                <AppWithNavigate   />  
                <Footer/>
            </div>
        )
    }
}
export default withRouter(UserEditProfile);;